import { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Space, Spin, Tag, message } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import styles from 'features/SenderDetails/Sender.module.less';
import { Constants, SenderStatus } from 'common/constants';
import { SenderModel } from 'common/models/BookingTypes';
import { useDispatch, useSelector } from 'react-redux';
import { SenderDetailsActions } from '@features/SenderDetails/store/SenderDetailsSlice';
import { GetAllSender, GetSenderById, SenderDetailsSelector } from '@features/SenderDetails';
import { PATHS } from '@routing/routes';
import { commonSelector } from '@features/Common/store/commonSelector';
import { commonAction } from '@features/Common/store/commonSlice';
import { UpdateTransactionSender } from '../business/BookingBusiness';
import { TransactionActions } from '@features/Transaction';
const { CheckableTag } = Tag;

export const SenderListingBooking = () => {
  const senderDetailsState = useSelector(SenderDetailsSelector);
  const commonState = useSelector(commonSelector);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleChange = (senderId: string) => {
    dispatch(commonAction.SetGlobalSenderId(senderId));
  };

  const [data, setData] = useState<SenderModel[]>([]);

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        await new Promise((resolve) => setTimeout(resolve, 500));
        const result = await GetAllSender(commonState.GlobalSenderUserId);

        if (
          result &&
          result.length > 0 &&
          (!senderDetailsState.SelectedId || senderDetailsState.SelectedId.trim() === '')
        ) {
          if (result[0]?.Address == null) {
            await dispatch(GetSenderById(result[0]?.Id));
            dispatch(SenderDetailsActions.SetSenderStatus(SenderStatus.Update));
            dispatch(SenderDetailsActions.SetSelectedId(result[0]?.Id));
            dispatch(SenderDetailsActions.SetFirstSender(true));
          }
        }
        setData(result);
      } catch (error) {
        // Handle error as needed
      }
    };
    fetchDataAsync();
  }, []);

  const onUpdate = async (value: any) => {
    if (value === null) return;
    await dispatch(GetSenderById(value));
    dispatch(SenderDetailsActions.SetSenderStatus(SenderStatus.Update));
    dispatch(SenderDetailsActions.SetSelectedId(value));
    dispatch(commonAction.SetGlobalSenderId(value));
    history.push(PATHS.Sender.path);
  };

  const AddNewSender = async () => {
    dispatch(TransactionActions.SetFromUpdateLinkFalse());
    dispatch(SenderDetailsActions.resetState());
    dispatch(SenderDetailsActions.SetSenderStatus(SenderStatus.New));
    history.push(PATHS.Sender.path);
  };

  const onFinish = async () => {
    if (commonState.GlobalSenderId === undefined) {
      message.warning('Please add a sender for this transaction.');
      return;
    }

    await dispatch(GetSenderById(commonState.GlobalSenderId));
    if (commonState.GlobalTransactionId) {
      await dispatch(
        UpdateTransactionSender({
          Id: commonState.GlobalTransactionId,
          SenderId: commonState.GlobalSenderId,
        })
      );
      message.success('Sender updated successfully');
      history.push(PATHS.TransactionSummary.path);
    }
  };
  return (
    <div className="App">
      <Form name="senderForm" layout="vertical" onFinish={onFinish}>
        <Row justify="center" align="middle">
          <h1>Sender list</h1>
        </Row>
        {data ? (
          <Row justify="center" align="middle">
            <Col>
              <Space wrap direction="vertical">
                {data.map((sender) => (
                  <div key={sender.Id} className={styles.FlexColumnContainer}>
                    <Row justify="center" align="middle">
                      <Col span={24} className={`${styles.rightText}`}>
                        <a className={styles.link} onClick={() => onUpdate(sender.Id)}>
                          Update
                        </a>
                      </Col>

                      <Col span={24}>
                        <CheckableTag
                          checked={sender.Id === commonState.GlobalSenderId}
                          onChange={() => handleChange(sender.Id)}
                          className={styles.anttagcheckable}
                        >
                          <div>
                            <div>
                              {sender.GivenName} {sender.Surname}
                            </div>
                            <div>
                              {sender.Address}, {sender.Suburb}, {sender.State}, {sender.PostalCode}
                            </div>
                            <div>{sender.Email}</div>
                            <div>
                              {sender.MobileCode} {sender.ContactNo}
                            </div>
                          </div>
                        </CheckableTag>
                      </Col>
                    </Row>
                  </div>
                ))}
              </Space>
            </Col>
          </Row>
        ) : (
          <Spin size="large" />
        )}
        <Row justify="center" align="middle">
          <Col>
            <br />
            <a className="normal-font" onClick={AddNewSender}>
              Add new sender
            </a>
          </Col>
        </Row>
        <br />
        <Row justify="center" align="middle">
          <Col xs={24} sm={8} md={14} lg={10} xl={7} xxl={5}>
            <Button
              className="prevSenderBtn"
              size="large"
              type="default"
              onClick={() =>
                history.push(!commonState.GlobalTransactionId ? PATHS.Home.path : PATHS.TransactionSummary.path)
              }
            >
              {!commonState.GlobalTransactionId ? Constants.BTN_CLOSE : Constants.BTN_BACK}
            </Button>
            <Button className="nextSenderBtn" size="large" type="primary" htmlType="submit">
              {!commonState.GlobalTransactionId ? Constants.BTN_CONTINUE : Constants.BTN_UPDATE}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
